const outpatient = (state = {}, action) => {
  switch(action.type){
    case 'ADD_OUTPATIENT':
      return action.data;

    case 'CLEAR_OUTPATIENT':
      return null;

    default:
      return state;
  }
}

export default outpatient